import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { onMessage } from "firebase/messaging";

/**
 * Register the SW at site root. Ensure `public/firebase-messaging-sw.js` exists
 * (generate it at build time if you use env vars).
 */
export async function registerMessagingSW() {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return null;
    try {
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
        console.log("Service Worker registered:", registration.scope);
        return registration;
    } catch (err) {
        console.error("SW registration failed:", err);
        return null;
    }
}

/**
 * Request notification permission, ensure SW is registered, then get FCM token.
 * Returns `{ token, registration }` or `null` on failure.
 */
export async function initPushMessaging() {
    if (typeof window === "undefined" || !("Notification" in window)) {
        console.warn("Notifications not supported");
        return null;
    }

    // register SW first so FCM can use it
    const registration = await registerMessagingSW();

    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "",
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
        appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
    };

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        console.warn("Notification permission not granted");
        return null;
    }

    onMessage(messaging, (payload) => {
        console.log('Message received in foreground: ', payload);
        // Manually show the notification
        // new Notification(payload.notification.title, {
        //     body: payload.notification.body,
        //     icon: payload.notification.icon,
        // });
    });

    try {
        const token = await getToken(messaging, {
            vapidKey,
            serviceWorkerRegistration: registration || undefined,
        });
        return { token };
    } catch (err) {
        console.error("getToken failed:", err);
        return null;
    }
}